import { IconButton } from "@material-ui/core";
import React from "react";
import { FormlLabelPartial, Label, Table, TableRow, ButtonContainer } from "../style";
import { DeleteForever as DeleteForeverIcon, Edit as EditIcon } from '@material-ui/icons'
import { addThousandSeparator } from "../../../utils/formatCurrency";


export const LogisticalLevelTable = (props) => {

    const { logisticalLevels } = props;

    return (
        <>
            <Label>Registro de patamares</Label>

            <Table>
                {(logisticalLevels && logisticalLevels.length) ?
                    logisticalLevels.map((logisticalLevel, index) => {
                        return (
                            <TableRow key={index}>
                                <FormlLabelPartial width="200px"><b>Até (km):</b> {logisticalLevel.radius}</FormlLabelPartial>
                                <FormlLabelPartial flex="1"><b>Valor (R$):</b> {addThousandSeparator(logisticalLevel.value)}</FormlLabelPartial>
                                <ButtonContainer>
                                    <IconButton
                                        onClick={() => props.onEdit(logisticalLevel)}
                                        color="primary"
                                        style={{ padding: 6 }}>
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton
                                        onClick={() => props.onDelete(logisticalLevel)}
                                        color="secondary"
                                        style={{ padding: 6 }}>
                                        <DeleteForeverIcon />
                                    </IconButton>
                                </ButtonContainer>
                            </TableRow>
                        )
                    }) : <i>Sem patamares cadastrados</i>}

            </Table>
        </>
    )
}
